export class StationEdgeInfo {
    constructor() {
        this.Width = 0;
        this.Metrolines = new Array();
        this.cachedBundleCost = 0;
    }
    get Count() {
        return this.Metrolines.length;
    }
}
//# sourceMappingURL=StationEdgeInfo.js.map